import { css } from '@emotion/react';

const modalStyles = css`
    .modal-dialog {
        max-width: 1000px;
        width: 90vw;
    }

    .button-container {
        display: flex;
        justify-content: center;

        button {
            border: 1px solid grey;
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
        }

        .accept-button {
            margin-left: 10px;
        }
    }

    .checkbox-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;

        input {
            margin-right: 5px;
        }

        label {
            display: flex;
        }
    }
`;

export const themeStyles = css`
    top: 0 !important;

    .modal-dialog {
        font-family: var(--modalComponent-fontFamily);
        font-size: var(--modalComponent-fontSize);
        font-weight: var(--modalComponent-fontWeight);
        padding: var(--modalComponent-padding);
        margin: var(--modalComponent-margin);
        max-width: var(--modalComponent-maxWidth);
    }

    .modal-content {
        display: var(--modalComponent-modalContentDisplay);
        flex-direction: var(--modalComponent-modalContentFlexDirection);
        width: var(--modalComponent-modalContentWidth);
        color: var(--modalComponent-modalContentColor);
        background-color: var(--modalComponent-modalContentBackgroundColor);
        border: var(--modalComponent-modalContentBorder);
        border-radius: var(--modalComponent-modalContentBorderRadius);
    }

    .modal-custom-header,
    .modal-header {
        display: var(--modalComponent-modalHeaderDisplay);
        align-items: var(--modalComponent-modalHeaderAlignItems);
        justify-content: var(--modalComponent-modalHeaderJustifyContent);
        border-bottom: var(--modalComponent-modalHeaderBorderBottom);
        border-top-left-radius: var(--modalComponent-modalHeaderBorderTopLeftRadius);
        border-top-right-radius: var(--modalComponent-modalHeaderBorderTopRightRadius);
        font-size: var(--modalComponent-modalHeaderFontSize);
        font-weight: var(--modalComponent-modalHeaderFontWeight);
        padding: var(--modalComponent-modalHeaderPadding);
        margin: var(--modalComponent-modalHeaderMargin);
    }

    .modal-body {
        font-size: var(--modalComponent-modalBodyFontSize);
        font-weight: var(--modalComponent-modalBodyFontWeight);
        padding: var(--modalComponent-modalBodyPadding);
        margin: var(--modalComponent-modalBodyMargin);
    }
`;

export default modalStyles;
